import { useState } from 'react';
import { conceptsAtom } from '../../../../services/atoms/concepts.atom';
import { useRecoilValue } from 'recoil';
import { useConceptsAction } from '../../../../services/actions/concepts.action';

const CompentenciesBases = [
  {
    id: 'PATRÓN DISC: DOMINANTE',
    code: 'dominant',
    title: 'DOMINANTE',
    subtitle: 'ROJO',
    color: 'red',
    concepts: [
      { id: 'Intensidad', text: 'Determinación' },
      { id: 'Orientación a Resultados', text: 'Orientación a resultados' },
      /* { id: uuidv4(), text: 'Productividad' },
      { id: uuidv4(), text: 'Resolución de Problemas' }, */
    ],
  },
  {
    id: 'PATRÓN DISC: INFLUYENTE',
    code: 'influent',
    title: 'INFLUYENTE',
    subtitle: 'AMARILLO',
    color: 'yellow',
    concepts: [
      { id: 'Impacto e Influencia', text: 'Impacto e influencia' },
      { id: 'Innovación', text: 'Innovación' },
      /* { id: uuidv4(), text: 'Desarrollo de relaciones' },
      { id: uuidv4(), text: 'Negociación' }, */
    ],
  },
  {
    id: 'PATRÓN DISC: ESTABLE',
    code: 'stable',
    title: 'ESTABLE',
    subtitle: 'VERDE',
    color: 'green',
    concepts: [
      { id: 'Inteligencia Emocional', text: 'Inteligencia Emocional' },
      { id: 'Visión Estratégica', text: 'Visión Estratégica' },
      /* { id: uuidv4(), text: 'Servicio' },
      { id: uuidv4(), text: 'Confiabilidad' }, */
    ],
  },
  {
    id: 'PATRÓN DISC: CONTROLADOR',
    code: 'analytic',
    title: 'ANALÍTICO',
    subtitle: 'AZUL',
    color: 'blue',
    concepts: [
      { id: 'Responsabilidad', text: 'Responsabilidad' },
      { id: 'Estructura', text: 'Estructura' },
      /* { id: uuidv4(), text: 'Organización y Planificación' },
      { id: uuidv4(), text: 'Pensamiento Analítico' }, */
    ],
  },
];

const Concepts = () => {
  const { listConcepts, getConceptsExcel, resetConcepts } = useConceptsAction();
  const [currentCompetency, setCurrentCompetency] = useState(null);
  const [currentConcept, setCurrentConcept] = useState(null);
  const { payload: conceptStorage, loading } = useRecoilValue(conceptsAtom);
  const [isDownloading, setIsDownloading] = useState(false);

  const handleButtonClick = (competencie, concept) => {
    setCurrentCompetency(competencie);
    setCurrentConcept(concept);
    listConcepts({
      typeCompetence: concept.id,
      profile: competencie.id,
    });
  };

  const onClickBack = () => {
    setCurrentCompetency(null);
    setCurrentConcept(null);
    resetConcepts();
  };

  const handleDownload = () => {
    setIsDownloading(true);
    
    getConceptsExcel((response) => {
      try {
        // Crear un blob a partir del ArrayBuffer
        const blob = new Blob([response], { 
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        });
        
        // Crear un objeto URL para el blob
        const url = window.URL.createObjectURL(blob);
        
        // Crear un enlace temporal para la descarga
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Banco de Conceptos - Competencias.xlsx');
        
        // Añadir el enlace al DOM, hacer clic y luego eliminarlo
        document.body.appendChild(link);
        link.click();
        
        // Limpieza después de un pequeño retraso para asegurar que la descarga comience
        setTimeout(() => {
          window.URL.revokeObjectURL(url);
          document.body.removeChild(link);
          setIsDownloading(false);
        }, 200);
      } catch (error) {
        console.error('Error al procesar la descarga:', error);
        alert('Se produjo un error al descargar el archivo. Por favor, inténtelo de nuevo más tarde.');
        setIsDownloading(false);
      }
    });
  };

  return (
    <div className="gm-configurations-screen-container">
      <div className="download-button-container">
        <button 
          className="download-button" 
          onClick={handleDownload} 
          disabled={isDownloading}
        >
          {isDownloading ? 'Descargando...' : 'Descargar'}
        </button>
      </div>
      {currentCompetency === null && currentConcept === null && (
        <div className="concepts-grid">

          {
            CompentenciesBases.map((item) => (
              <div className={`concept-card ${item.code}`} key={item.id}>
                <div className="gm-card-header">
                  <h3>{item.title}</h3>
                  <p>{item.subtitle}</p>
                </div>
                <div className="gm-card-body">
                  {
                    item.concepts.map((concept) => (
                      <button
                        className={`concept-button ${item.color}`}
                        key={concept.id}
                        onClick={() => handleButtonClick(item, concept)}>
                          {concept.text}
                      </button>
                    ))
                  }
                </div>
              </div>
            ))
          }

        </div>
      )}

      {currentCompetency !== null && currentConcept !== null && (
        <div className="concept-card">
          <div className="gm-concepts-card-header">
            <button className="back-button" onClick={onClickBack}>&lt;</button>
            <div>
              <h3>{currentCompetency.title}</h3>
              <p>{`${currentCompetency.subtitle} / ${currentConcept.text}`}</p>
            </div>
          </div>
          <div className="gm-card-body">
            <div className="concepts-grid">

              {
                (conceptStorage.length > 0) && conceptStorage.map((concept) => (
                  <p className={`concept-item ${currentCompetency.color}`} key={concept.name}>{concept.name}</p>
                ))
              }

              {
                (conceptStorage.length === 0) && !loading &&
                  <p>Aún no hay conceptos disponibles.</p>
              }

              {
                loading && <p>Cargando...</p>
              }

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Concepts;
